var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "member-confirm-unfollow-container" },
    [
      _c("modal-background", { staticClass: "modal-background" }),
      _vm._v(" "),
      _c("div", { staticClass: "member-confirm-unfollow-popup" }, [
        _c("p", [
          _vm._v(
            "フォローを解除します。解除した方とのチャットが見れなくなります。よろしいですか？"
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "member-confirm-unfollow-action" }, [
          _c(
            "button",
            {
              staticClass: "member-confirm-unfollow-action-cancel",
              attrs: { type: "button" },
              on: { click: _vm.cancelUnfollow }
            },
            [_vm._v("\n              キャンセル\n          ")]
          ),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "member-confirm-unfollow-action-create",
              attrs: { type: "submit" },
              on: { click: _vm.acceptUnfollow }
            },
            [_vm._v("\n              はい\n          ")]
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }